import { iActionSetup } from '~/domain/interfaces/redux/chat/setup';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onSetup(action: iActionSetup): void {}
